import Base from 'app/views/base';

import { setLocation } from 'utils/wrappers';
import { showSuccess, showResponseError } from 'utils/messages';

import EmailVerification from 'app/models/email_verification';

import tmpl from 'templates/verification_splash';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit #email_verification_form': 'submit',
  },

  initialize() {
    this.model = new EmailVerification({});
  },

  context() {
    return {
      code: this.$('#email_verification_code').val() || '',
    };
  },

  submit(e) {
    e.preventDefault();
    const code = this.$('#email_verification_code').val();
    this.model.save({ id: code }, {
      success() {
        showSuccess('Success! Verification complete. You may now sign in.');
        setLocation('/signin');
      },
      error(model, response) {
        showResponseError(response);
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/verification_splash_page.js